<template>
    <ScreenLayout :title="'Download Contacts - ' + officeName " ref="screenLayout" :rightVisible="true">
        <template slot="left">
            <div style="padding:60px">

            <v-icon size="120" color="#ddd">arrow_circle_down</v-icon>
            </div>
        </template>

        <div class="pa-5">
            Contacts will be downloaded to CSV (comma separated) which will open in Excel.<br/><br/>
            
            You have {{contacts.length}} contacts
            <br><br>
<vue-json-to-csv :json-data="contacts"
  :labels="{ 
      firstName: { title: 'First name' },
      lastName: { title: 'Last name' },
      mobile: { title: 'Mobile' },
      email: { title: 'Email' },
      address: { title: 'Address' },
    }"
  csv-title="Contacts"
  >
  <v-btn rounded class="primary">
    Download
  </v-btn>
    </vue-json-to-csv>
        </div>
        

        <template slot="right">
&nbsp;
            </template>

    </ScreenLayout>
</template>

<script>
import LayoutContainer2 from '@/ui-elements/LayoutContainer2'
import SectionLayout from '@/screens/SectionLayout'
import ElementControl from '@/screens/ElementControl'
import ElementLayout from '@/screens/ElementLayout'
import LayoutReadOnly from '@/ui-elements/LayoutReadOnly'
import ElementMenu from '@/screens/ElementMenu'
import ScrollHelpers from '../helpers/ScrollHelpers'
import DataHelpers from '../helpers/DataHelpers'
import ScreenLayout from '../screens/ScreenLayout'
import PageLayout from '../screens/PageLayout'
import AutomaticScroll from '@/ui-elements/AutomaticScroll'
import VueJsonToCsv from 'vue-json-to-csv'
import NiceData from '../data/NiceData'


export default {
    data() {
        return {
            contacts: [],
        }
    },

    components: {
        ScreenLayout,
        PageLayout,
        LayoutContainer2,
        SectionLayout,
        ElementLayout,
        LayoutReadOnly,
        ElementMenu,
        ElementControl,
        AutomaticScroll,
        VueJsonToCsv,
    },
    
    props: {
        // item: Object,
    },

    computed: {
        officeName() {
            return DataHelpers.officeName()
        }
    },

    methods: {

        scrolled(key) {
            this.activeMenuKey = key
        },

        elementMenuClicked(item, section) {
            this.activeMenuKey = (section ? section.key : item.key)
            this.activeElement = item
        },
    },

    async created() {
        let ref = DataHelpers.getTenantRef().child('contacts')
        this.contacts = await NiceData.fetchItemsFromFirebase(ref)
    },

    mounted() {
        
    }

}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// DownloadPage.vue?35b0ed00